import { useState, useCallback } from 'react';

const storageKey = (userId) => `nestwise-tour-seen-${userId}`;

export function useDashboardTour(steps, userId) {
  const [active, setActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const hasSeenTour = useCallback(() => {
    return window.localStorage.getItem(storageKey(userId)) === 'true';
  }, [userId]);

  const markSeen = useCallback(() => {
    window.localStorage.setItem(storageKey(userId), 'true');
  }, [userId]);

  const start = useCallback(() => {
    setCurrentStep(0);
    setActive(true);
  }, []);

  const finish = useCallback(() => {
    markSeen();
    setActive(false);
  }, [markSeen]);

  const skip = useCallback(() => {
    markSeen();
    setActive(false);
  }, [markSeen]);

  const next = useCallback(() => {
    if (currentStep >= steps.length - 1) {
      finish();
    } else {
      setCurrentStep((step) => Math.min(step + 1, steps.length - 1));
    }
  }, [currentStep, steps.length, finish]);

  const back = useCallback(() => {
    setCurrentStep((step) => Math.max(0, step - 1));
  }, []);

  return {
    active,
    currentStep,
    currentStepData: active ? steps[currentStep] : null,
    totalSteps: steps.length,
    start,
    next,
    back,
    skip,
    finish,
    hasSeenTour,
  };
}
